import { render, staticRenderFns } from "./DataFListIntra.vue?vue&type=template&id=2703b254&scoped=true"
import script from "./DataFListIntra.vue?vue&type=script&lang=js"
export * from "./DataFListIntra.vue?vue&type=script&lang=js"
import style0 from "./DataFListIntra.vue?vue&type=style&index=0&id=2703b254&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703b254",
  null
  
)

export default component.exports